import React from 'react'
import cx from 'classnames'
import Header from 'lib/components/header'
import MethodTooltip from './method-tooltip'
import Footer from 'lib/components/footer'
import WelcomeDialog from './welcome/dialog'
import MobileHeader from './mobile/header'
import Match from 'lib/components/match'

import LOGO_URL from 'lib/images/logo.svg'

export default function Layout({
  children,
  query,
  region,
  section = 'strategies'
}) {
  const className = cx('dashboard', {
    '-selected': 'selected' in query
  })

  return (
    <div className="app-layout">
      <h1 className="screenreader-only">Smart Beta Interactive Dashboard</h1>

      <Match max="small-max">
        <p className="app-layout__disclaimer">
          This site is best experienced on desktop.
        </p>
      </Match>

      <WelcomeDialog />

      <Match min="medium-min">
        <Header
          region={region}
          logoUrl={LOGO_URL}
          navAuxContent={MethodTooltip}
        />
      </Match>

      <Match max="small-max">
        <MobileHeader region={region} section={section} />
      </Match>

      <div className={className}>{children}</div>

      <Footer />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/layout.js